import { authHeaders } from '@classes/auth_service'
import { toastError, toastSuccess } from '@constants/toasts'
import { getServerUrl } from '@hooks/useApi'
import Logger from '@logger'
import axios from 'axios'

const logger = Logger.create('callApi')

type HttpVerb = 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH'

export const callApi = async (url: string, method: HttpVerb = 'GET', body?: unknown, successMessage?: string, rethrowError?: boolean) => {
  const showMessage = (message?: string) => {
    if (message) {
      toastSuccess(message)
    }
  }

  const config = { headers: authHeaders(url) }

  if (!url.startsWith('http')) {
    url = getServerUrl(url)
  }

  try {
    if (method === 'GET') {
      const { data } = await axios.get(url, config)
      showMessage(successMessage)
      return data
    } else if (method === 'POST') {
      const { data: postData } = await axios.post(url, body, config)
      showMessage(successMessage)
      return postData
    } else if (method === 'PUT') {
      const { data: putData } = await axios.put(url, body, config)
      showMessage(successMessage)
      return putData
    } else if (method === 'PATCH') {
      const { data: patchData } = await axios.patch(url, body, config)
      showMessage(successMessage)
      return patchData
    } else if (method === 'DELETE') {
      const { data: deleteData } = await axios.delete(url, { ...config, data: body })
      showMessage(successMessage)
      return deleteData
    }
  } catch (error) {
    logger.error(`error while performing ${method} request to ${url}: ${error}`, { body })
    if (rethrowError) {
      throw error
    } else {
      const errorMessage = error instanceof Error ? error.message : 'Something went wrong, try again'
      toastError(errorMessage)
    }
  }
}
